export function resolveFiscalInvoiceLabel(params: {
  fiscalMode?: string | null;
  fiscalStatus?: string | null;
  invoiceCae?: string | null;
}): string | null {
  if (params.fiscalMode === 'non_fiscal') return null;
  if (params.invoiceCae?.trim()) return 'Factura emitida';
  const fs = params.fiscalStatus?.toLowerCase() ?? '';
  if (fs === 'approved') return 'Factura emitida';
  if (fs === 'pending_retry' || fs === 'pending' || fs === 'pending_sync') return 'Factura pendiente';
  return 'Comprobante fiscal';
}
